 <!-- info // warning -->
<symbol-alert [typeAlert]="'warning'"></symbol-alert>


<div mat-dialog-content>
  <div class="pt-5 error-message" >
    <div class="font-semibold text-2xl"> ¡Tu sesión está a punto de expirar!</div>
    <div class="text-lg pt-5">Estimado usuario, tu sesión se cerrará en</div>
    <div class="text-lg">{{ countdown}} segundos</div>
    <div class="text-lg">¿Deseas continuar con tu sesión?</div>
  </div>
</div>

<div class="row pt-10">
  <div class="col-md-10 offset-md-1">
    <div class="row">
      <div class="col-6"><button mat-raised-button class="btn btn-secondary btn-block" (click)="renewSession()">Mantener sesión</button></div>
      <div class="col-6"><button mat-raised-button class="btn btn-finish btn-block" (click)="closeSession()">Cerrar sesión</button></div>
    </div>
  </div>
</div>